import { makeStyles } from '@material-ui/core/styles'
const useStyles = makeStyles(
  () => ({
    root: {
      fontSize: '1.25em',
      color: '#6F6F6F',
      letterSpacing: '0px',
      fontWeight: 'bold',
    },
    signin: {
      position: 'absolute',
      bottom: '15.625em',
      right: '8.75em',
      height: '31.875em',
      width: '25em',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'flex-start',
      '@media (max-width: 1400px),(max-height: 800px)': {
        position: 'absolute',
        bottom: '5.625em',
        right: '5.75em',
        height: '27.875em',
        width: '22em',
      },
      '@media (min-height: 1400px)': {
        position: 'absolute',
        bottom: '25.625em',
        right: '15.75em',
        height: '35.875em',
        width: '28em',
      },
    },
    signintext: {
      height: '16%',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-around',
      //   border: '2px solid red',
    },
  }),
  { index: 1 },
)

export { useStyles }
